<template>
    <div class="app-drawer-overlay animated fadeIn" :class="{'d-none':!show}"></div>
</template>

<script>
    export default {
        name: "t-app-blackout",
        computed:{
            show(){
                return this.$store.getters.getCurrentPageBlackoutShow
            }
        }
    }
</script>

<style scoped>

</style>